/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdatePromptRequest interface.
 */
export function instanceOfUpdatePromptRequest(_value) {
    return true;
}
export function UpdatePromptRequestFromJSON(json) {
    return UpdatePromptRequestFromJSONTyped(json, false);
}
export function UpdatePromptRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'] == null ? undefined : json['description'],
        'minTrafficShare': json['minTrafficShare'] == null ? undefined : json['minTrafficShare'],
        'name': json['name'] == null ? undefined : json['name'],
        'systemPrompt': json['systemPrompt'] == null ? undefined : json['systemPrompt'],
        'userPromptTemplate': json['userPromptTemplate'] == null ? undefined : json['userPromptTemplate'],
    };
}
export function UpdatePromptRequestToJSON(json) {
    return UpdatePromptRequestToJSONTyped(json, false);
}
export function UpdatePromptRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
        'minTrafficShare': value['minTrafficShare'],
        'name': value['name'],
        'systemPrompt': value['systemPrompt'],
        'userPromptTemplate': value['userPromptTemplate'],
    };
}
